import { getLocale } from "app/helpers/session";
import * as React from "react"

let locale = null
let localeIndex = null
import * as Sentry from '@sentry/browser';
import { LocaleType, LangPrefixType } from "./index";

function supplant(message, variables, fallback: string | number = null, formatter = null) {
    if (typeof message !== "string") {
        try {
            throw new Error('Message is not string');
        }
        catch (e) {
            console.error(e);
            Sentry.captureException(e);
        }
        return ""
    }
    return message.replace(/{([^{}]*)}/g,
        function (a, b) {
            if (variables[b] !== undefined) {
                if (formatter !== null) {
                    return formatter(variables[b])
                }
                return variables[b]
            }
            if (fallback !== null) {
                return fallback
            }
            return '{?}'
        }
    );
}

function getLocaleIndex(locale) {
    switch (locale) {
        case "sk_SK":
            return 1
        case "cs_CZ":
            return 0
        case "en_EN":
            return 2
        case "pl_PL":
            return 3
        case "hu_HU":
            return 4
        default:
            return 0
    }
}

const trans_cache: any = {}


interface Trans {
    locale: string[]
    messages: {
        [key: string]: any[]
    }
}

export function tr(trans, key, variables: any = null, formatter = null, multilang = false) {
    if (!key) {
        return ""
    }

    if (trans_cache[key] !== undefined && variables === null) {
        return trans_cache[key]
    }

    let message = key
    if (typeof trans[key] !== "undefined") {
        if (multilang === false) {
            message = trans[key]
        } else {
            if (locale === null) {
                locale = getLocale()
            }
            if (localeIndex === null) {
                localeIndex = getLocaleIndex(locale)
            }
            message = trans[key][localeIndex]
        }
    } else {
        try {
            throw new Error('Missing translation: ' + key);
        } catch (e) {
            console.error(e);
            Sentry.captureException(e);
        }
    }

    if (variables && message && message.count) {
        message.count.some((m, n) => {
            try {
                if (m.if && eval(m.if.replace(/{n}/g, variables.n))) {
                    message = supplant(m.then, variables, 0, formatter)
                    return true
                }
                if (m.else) {
                    message = supplant(m.else, variables, 0, formatter)
                    return true
                }
            } catch (e) {
                console.log(key, m.if, variables)
            }
        })
    } else
        if (variables && message && message.string) {
            message.string.some((m, n) => {

                if (Object.keys(variables).length > 0 && m.if) {
                    let ret = false
                    Object.keys(variables).forEach(variable => {
                        if (eval(m.if.replace('{' + variable + '}', variables[variable]))) {
                            message = supplant(m.then, variables, "", formatter)
                            ret = true
                        }
                    })
                    if (ret) {
                        return true
                    }
                }
                if (m.else) {
                    message = supplant(m.else, variables, "", formatter)
                    return true
                }
            })
        } else
            if (variables !== null && message) {
                if (message.indexOf('{{') > -1 && message.indexOf('}}') > -1) {
                    const matches = message.matchAll(RegExp('{{(.*?)}}', 'g'))
                    const ret = []
                    let start = 0
                    let end = 0

                    for (const match of matches) {
                        end = match.index
                        ret.push(message.substring(start, end))
                        start = match.index + match[0].length
                        const variable = match[0].replace('{{', '').replace('}}', '')
                        ret.push(variables[variable])
                    }
                    ret.push(message.substring(start))

                    return ret
                } else {
                    message = supplant(message, variables, null, formatter);
                }
            }

    if (typeof message !== "string") {
        return key
    }

    if (message.indexOf('</') > -1 || message.indexOf('/>') > -1) {
        return <span dangerouslySetInnerHTML={{ __html: message }} />
    }
    // if(variables === null) {
    //     trans_cache[key] = message
    // }
    return message
}

export type Transform = {
    x: number
    y: number
    scale: number
}

export function parseTransformAndScale(translateString: string): Transform {
    const result = translateString ? translateString.match(/translate\(([-+0-9.\s]+px),([-+0-9.\s]+px)\)\s+scale\(([0-9.\s]+)\)/i) : null
    if (result && result[1] && result[2]) {
        return {
            x: parseFloat(`${result[1].replace('px', '')}`),
            y: parseFloat(`${result[2].replace('px', '')}`),
            scale: result[3] ? parseFloat(`${result[3]}`) : 1,
        }
    }

    return {
        x: 0,
        y: 0,
        scale: 1
    }
}

export function getLangPrefixFromOutputFormat(projectType: string): LangPrefixType {
    if (!projectType) {
        return "cz"
    } else if (projectType.includes('.cz')) {
        return "cz"
    } else if (projectType.includes('.sk')) {
        return "sk"
    } else if (projectType.includes('.hu')) {
        return "hu"
    } else if (projectType.includes('.pl')) {
        return "pl"
    }

    return "en"
}